import styled from 'styled-components';

interface EntryProps {
	selected: boolean;
}
export const Entry = styled.div<EntryProps>`
	// layout
	height: 24px;
	display: flex;
	align-items: center;
	padding-left: 8px;
	margin-right: 6px;
	gap: 8px;
	// style
	color: ${({ theme }) => theme.gray[1000]};
	border-radius: 6px;
	background-color: ${({ theme, selected }) => (selected ? theme.blue[300] : 'transparent')};
	font-size: 11px;
	font-weight: 500;
	&:hover {
		background-color: ${({ theme, selected }) => (selected ? theme.blue[300] : theme.gray[200])};
	}
	flex-shrink: 0;
`;

export const EntryText = styled.div`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	margin-top: -1px;
`;

export const Top = styled.div`
	display: flex;
	flex-direction: column;
	overflow: hidden;
`;

export const SceneNameRow = styled.div<{
	makeSpaceForSidebar: boolean;
	sidebarToggleWidth: number;
}>`
	display: flex;
	align-items: center;
	height: 36px;
	padding-left: ${({ makeSpaceForSidebar, sidebarToggleWidth }) =>
		makeSpaceForSidebar ? sidebarToggleWidth + 8 : 12}px;
	padding-right: 12px;
	padding-top: 10px;
	padding-bottom: 10px;
`;

export const Items = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	flex: 1;
	min-height: 0;
	overflow-y: auto;
`;

export const EntryIcon = styled.div`
	flex-shrink: 0;
`;
